//lib
import { Swiper, SwiperSlide } from "swiper/react";
import { Icon } from "@iconify/react";

//redux
import { useSelector } from "react-redux";

//component
import Row from "../../../components/element/row";
import Container from "../../../components/element/container";
import CommonProduct from "../../../components/common/common.product";

import { useTranslation } from "react-i18next";

export default function HomeDeal({ className }) {
  const { t } = useTranslation();
  const { savedProduct } = useSelector((state) => state.product);
  const { productList, productListLoading } = useSelector(
    (state) => state.product,
  );

  const discountProductList = productList?.["discount_products"] || [];

  return (
    discountProductList?.length > 0 && (
      <Container className={`home-deal ${className ?? ""}`}>
        <Row className="_row deal-heading-row items-center gap-50">
          <Icon
            icon="material-symbols:star-outline"
            className="_svg exclusive"
          />
          <p className="_label deal-title">{t("Exclusive")}</p>
        </Row>
        <Swiper
          touchStartPreventDefault={false}
          grabCursor={true}
          spaceBetween={15}
          slidesPerView="auto"
          className="_row deal-list"
        >
          {productListLoading &&
          savedProduct?.length === 0 &&
          discountProductList?.length === 0
            ? Array.from({ length: 3 }, (_, productSkeleton) => (
                <SwiperSlide key={`deal-skeleton-${productSkeleton}`}>
                  <CommonProduct
                    loading={true}
                    key={productSkeleton}
                    type="deal"
                  />
                </SwiperSlide>
              ))
            : discountProductList?.length > 0 &&
              discountProductList.map((product, productIndex) => (
                <SwiperSlide key={product.id || `deal-${productIndex}`}>
                  <CommonProduct
                    product={product}
                    key={productIndex}
                    type="deal"
                  />
                </SwiperSlide>
              ))}
        </Swiper>
      </Container>
    )
  );
}
